export default __webpack_public_path__ + "static/media/maki_arrow.a25f4b4f.svg";